import React, { useState } from "react";
import { Candidate } from "../../../store/types/candidate";
import PDFPreview from "../../../components/elements/PDFPreview";

interface ViewCandidateModalProps {
  candidateData: Candidate | null;
  onClose: () => void;
}

const ViewCandidateModal: React.FC<ViewCandidateModalProps> = ({
  candidateData,
  onClose,
}) => {
  const [showPdf, setShowPdf] = useState(false);

  if (!candidateData) return null;
  console.log("CV URL:", candidateData.cvUrl);

  return (
    <div className="">
      <p className="text-20 font-bold mb-5 text-center">Candidate Details</p>
      
      <div className="space-y-4">
        <div>
          <label className="text-sm text-gray-500">Name</label>
          <p className="font-medium text-lg">{candidateData.name}</p>
        </div>
        
        <div>
          <label className="text-sm text-gray-500">Email</label>
          <p className="font-medium text-lg">{candidateData.email}</p>
        </div>
        
        <div>
          <label className="text-sm text-gray-500">Phone Number</label>
          <p className="font-medium text-lg">{candidateData.phoneNumber}</p>
        </div>
        
        <div>
          <label className="text-sm text-gray-500">Occupation</label>
          <p className="font-medium text-lg">
            {candidateData.jobTitle
              ?.replace(/_+/g, " ")
              .toLowerCase()
              ?.replace(/\b\w/g, (char) => char.toUpperCase())}
          </p>
        </div>
        
        <div>
          <label className="text-sm text-gray-500">Location</label>
          <p className="font-medium text-lg">{candidateData.address || "N/A"}</p>
        </div>

        {candidateData.cvUrl && (
          <div className="pt-2">
            <button
              onClick={() => setShowPdf(true)}
              className="w-full py-2 px-4 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
            >
              View CV
            </button>
          </div>
        )}
      </div>

      <div className="mt-6 flex justify-end">
        <button
          onClick={onClose}
          className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
        >
          Close
        </button>
      </div>

      {candidateData.cvUrl && (
        <PDFPreview
          fileUrl={candidateData.cvUrl}
          isOpen={showPdf}
          onClose={() => setShowPdf(false)}
        />
      )}
    </div>
  );
};

export default ViewCandidateModal;
